import { useCallback } from "react";
import { useNavigate } from "@hooks/useNavigate/useNavigate";
/**
 * Reloads the page with the specified query parameters removed and the rest persisted.
 * @param queryToRemove - The query parameters to remove.
 * @returns A function that reloads the page with the specified query parameters removed.
 */
export const useReloadHomePageWithQuery = () => {
  const navigate = useNavigate();

  return useCallback(
    (queryToRemove: string[] = [], shouldHardReload = false) => {
      navigate(`/`, { searchParamsToRemove: queryToRemove });
      if (shouldHardReload) {
        window.location.reload();
      } else {
        navigate(0);
      }
    },
    [navigate],
  );
};
